import { useTranslation } from 'react-i18next';
import ScrollToTopBadge from '../../component/ScrollToTop';
import LandingpageHeader from '../header/LandingpageHeader';
import Footer from './Footer';
import styles from './footer.module.scss';
import { useEffect } from 'react';

export default function FooterContact() {
    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <LandingpageHeader />

            <ScrollToTopBadge />

            <div className="container">

                <article>

                    <h1 className={styles.ueb}>{t('deTranslation.footerContact.title')}</h1>

                    <div className={styles.pre1}>
                        ASG Aufmassdienst für den Küchenfachhandel<br />
                        Buchenstraße 16a<br />
                        26687 Apen/Nordloh<br />
                        <br />
                        Arnd-Steffen Glashagen<br />
                        E-Mail: buero@asg-aufmass.de<br />
                        Tel.: 0171 8927809<br />
                        <br />
                        https://web.asg-aufmass.de<br />
                    </div>

                </article>

            </div>

            <Footer />
        </>
    );
}
